import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Layout } from './components/Layout';
import { Toast } from './components/ui/Toast';
import './i18n';

function App() {
  const { t, i18n } = useTranslation('common');

  const pageTitle = t('meta.title', 'MamaQR — Free QR Code Generator & Designer');
  const pageDescription = t('meta.description', 'Create, customize, and download QR codes for free. No sign-up, no tracking — everything runs in your browser.');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "MamaQR",
    "operatingSystem": "Any",
    "applicationCategory": "UtilitiesApplication",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": pageDescription
  };

  return (
    <HelmetProvider>
      <Helmet>
        <html lang={i18n.language} dir={i18n.dir()} />
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        
        {/* Dynamic Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="twitter:title" content={pageTitle} />
        <meta property="twitter:description" content={pageDescription} />
        
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <Layout />
      <Toast />
    </HelmetProvider>
  );
}

export default App;
